import TheFooter from "./TheFooter";

export {TheFooter}
export default TheFooter
